module.exports = __webpack_public_path__ + "img/yuetong.62dd7a82.png";